import FormControl from "@material-ui/core/FormControl"
import Grid from "@material-ui/core/Grid"
import InputLabel from "@material-ui/core/InputLabel"
import TextField from "@material-ui/core/TextField"
import React, { useContext } from "react"
import FieldSelect from "Components/Table/FieldSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import ChargePerson from "../ChargePerson"
import { useWeChatModalStyle } from "./style"
import { useCreateWeChat } from "./hooks"
import { AppContext } from "Views/Home/context"

const WeChatMultipleCreate = () => {
    const classes = useWeChatModalStyle()
    const {
        callback, cancelCallback,
        dialogData, disabled, modalTimeStr,
        text, handleChange,
        handleChangeAuthor,
        handleChangeArticleType,
        staticArticleType,
    } = useCreateWeChat()
    const { roleMap } = useContext(AppContext)
    const { isTrueEditor, isOpEditor } = roleMap
    return (
        <BoardConfirmModal
            title="创建预约"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid item>
                <div className={classes.timeBlock}>
                    {modalTimeStr}
                </div>
                <Grid item>
                    <TextField
                        label="内容"
                        value={text}
                        onChange={handleChange}
                        className={classes.input}
                    />
                </Grid>
                <Grid item>
                    <FormControl className={classes.input}>
                        <InputLabel >文章类型</InputLabel>
                        <FieldSelect
                            tableName="article_type"
                            onChange={handleChangeArticleType}
                            staticValueList={staticArticleType}
                            // 2026-03 文章类型=“说明” 仅编辑部主编可预约
                            whereQuery={`where: {hidden: {_eq: false}${!isTrueEditor ? ', name: {_neq: "说明"}' : ''}}`}
                        />
                    </FormControl>
                </Grid>
                {/*除编辑部主编和编辑部运营外的角色在预约微信点位时，不再需要填写“负责人”*/}
                { (isTrueEditor || isOpEditor) && (
                    <Grid item>
                        <FormControl className={classes.input}>
                            <InputLabel>负责人</InputLabel>
                            <ChargePerson handleChangeAuthor={handleChangeAuthor}/>
                        </FormControl>
                    </Grid>
                ) }
            </Grid>
        </BoardConfirmModal>
    )
}

export default WeChatMultipleCreate
